<template>
  <div class="about-us" oncontextmenu="return false" onselectstart="return false">
    <!--顶部-->
    <header-nav :current="current"></header-nav>
    <div class="content" id="pdfDom" ref="content">
      <div class="table" :class="{'pdfheight': isPrint}">
        <h1 class="title">
          <b>
            【汉语儿童理解与表达词汇测验】
            <br/><br/>三至六岁儿童个人报告
          </b>
        </h1>
        <div class="author">
          <p>
            <i>
              Receptive and Expressive Vocabulary Test （REVT）
            </i>
          </p>
          <p>黄瑞珍、简欣瑜、朱丽璇、卢璐编制</p>
        </div>

        <div class="head-title">
          <p class="title3 tx-l">基本资料</p>
          <p class="title3 tx-l">个案编号：{{baseInfo.sn}}</p>
        </div>
        <table border="1" cellspacing="1" cellpadding="0">
          <tr>
            <th width="140px">姓名</th>
            <td>
              <div class="input">
                <span>{{baseInfo.name}}</span>
              </div>
            </td>
            <th width="140px">评估日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.exam_date}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">性别</th>
            <td>
              <div class="input">
                <span>{{baseInfo.sex}}</span>
              </div>
            </td>
            <th width="140px">出生日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.birthday}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">地区</th>
            <td>
              <div class="input">
                <span>{{baseInfo.province}}</span>
              </div>
            </td>
            <th width="140px">实足年龄</th>
            <td>
              <div class="input">
                <span>{{baseInfo.age}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">就读学校</th>
            <td>
              <div class="input">
                <span>{{baseInfo.school}}</span>
              </div>
            </td>
            <th width="140px">施测人员</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">转介者</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_user}}</span>
              </div>
            </td>
            <th width="140px">施测地点</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator_area}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">转介理由</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_reason}}</span>
              </div>
            </td>
            <th width="140px"></th>
            <td>
              <div class="input">
                <span>{{baseInfo.create_time}}</span>
              </div>
            </td>
          </tr>
        </table>
        <p class="title3 tx-l">量表介绍</p>
        <table border="1" cellspacing="1" cellpadding="0">
          <tr>
            <th>
              <p class="tips tx-idt2">
                《汉语儿童理解与表达词汇测验》（REVT）由黄瑞珍、简欣瑜、朱丽璇、卢璐参考国内外文献，从认知发展的角度探讨儿童词汇学习的特质与进程，同时参考汉语词汇特性编制本测验，并本着严谨的态度保证其验证结果的信效度。本测验分成理解与表达两个量表，以下又细分为四个分测验。测验目的是帮助使用者理解学龄前儿童的词汇发展，用来鉴定词汇发展迟缓儿童，以利于早期介入、早期疗育。
              </p>
              <p class="tips tx-idt2">
                理解量表：理解（receptive；简称R）是指对于言辞意义的了解或解碼，代表听话者了解他人说话内容的能力。理解量表主要以施测者依据题本给予指示，请儿童依据题目要求进行词汇选择。量表内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
              </p>
              <p class="tips tx-idt2">
                表达量表：表达（expressive；简称E）则是指使用言辞概念说出的过程或编码，表示个人产生有意义言语的能力。表达量表施测方式为施测者依据题目提问，儿童以口述的方式表达自己对词汇的概念。测验内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
              </p>
            </th>
          </tr>
        </table>
      </div>
      <!-- 分测验分数结果 -->
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="title3 tx-l">分测验分数结果</p>
        <div class="charts" id="charts2"></div>
        <!-- 表格列出所有分数 -->
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
              <!--              <div class="out">-->
              <!--                <b class="table-cate">分数</b>-->
              <!--                <em>类别</em>-->
              <!--              </div>-->
            </th>
            <th style="width: 189px">命名</th>
            <th style="width: 189px">归类</th>
            <th style="width: 188px">定义</th>
            <th style="width: 190px">推理</th>
          </tr>
          <template>
            <tr v-for="(score,index) in cateEchart.table" :key="index">
              <td class="score-td-title">
                <template v-if="index == 0">
                  原始分数
                </template>
                <template v-if="index == 1">
                  标准分数
                </template>
                <template v-if="index == 2">
                  百分等级
                </template>
              </td>
              <td class="score-td">{{ score[0] }}</td>
              <td class="score-td">{{ score[1] }}</td>
              <td class="score-td">{{ score[2] }}</td>
              <td class="score-td">{{ score[3] }}</td>
            </tr>
          </template>
        </table>
        <p class="title3 tx-l">量表分数结果</p>
        <div class="charts" id="charts3"></div>
        <!-- 表格列出所有分数 -->
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
              <!--              <div class="out">-->
              <!--                <b class="table-cate">类型</b>-->
              <!--                <em>分数</em>-->
              <!--              </div>-->
            </th>
            <th style="width: 256px !important;">理解量表</th>
            <th style="width: 256px !important;">表达量表</th>
            <th style="width: 256px !important;">全测验</th>
          </tr>
          <template>
            <tr v-for="(score,index) in allEchart.table" :key="index">
              <td class="score-td-title">
                <template v-if="index == 0">
                  原始分数
                </template>
                <template v-if="index == 1">
                  标准分数
                </template>
                <template v-if="index == 2">
                  百分等级
                </template>
              </td>
              <td class="score-td">{{ score[0] }}</td>
              <td class="score-td">{{ score[1] }}</td>
              <td class="score-td">{{ score[2] }}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">

        <p class="title3 tx-l" v-if="tip">分数说明</p>
        <table border="1" v-if="tip">
          <tr>
            <td style="width: 75px;">分测验标准分数</td>
            <td>
              分测验标准分数是以10为平均数、3为标准差，标准分数介于1-19之间，以此分成七个等级：能力不足（1-3）、低下（4-5）、中下（6-7）、中等普通（8-12）、中上（13-14）、优秀（15-16）及非常优秀（17-19）。
            </td>
          </tr>
          <tr>
            <td style="width: 75px;">量表与全测验标准分数</td>
            <td>
              量表與全測驗标准分数是以100为平均数、15为标准差转换而成。本量表將标准分数分成七个等级：能力不足（≦69）、低下（70-79）、中下（80-89）、中等普通（90-109）、中上（110-119）、优秀（120-129）及非常优秀（≧130）。
            </td>
          </tr>
          <tr>
            <td style="width: 75px;">百分等级</td>
            <td>
              百分等级是依据常模数据换算而得，代表受试者在100个人当中所排列的位置，来检视儿童语言发展。在本量表百分等级愈高，代表表现愈佳，以此了解儿童在该年龄组的得分情形。            </td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="title3 tx-l">分测验介入计划与建议</p>
        <table border="1">
          <template>
            <tr v-for="(result,index) in cateResult" :key="index">
              <td style="width: 75px;">{{ result.title }}</td>
              <td>
                {{result.res}}
                <template v-if="result.title === '命名' && result.score > 3 && result.score <= 5">
                  <img src="../../assets/revt/name_4-5.png" alt="">
                </template>
                <template v-if="result.title === '归类' && result.score > 3 && result.score <= 5">
                  <img src="../../assets/revt/cate_4-5.png" alt="">
                </template>
                <template v-if="result.title === '归类' && result.score > 5 && result.score <= 7">
                  <img src="../../assets/revt/cate_6-7.png" alt="">
                </template>
                <template v-if="result.title === '定义' && result.score > 5 && result.score <= 7">
                  <img src="../../assets/revt/dingyi_6-7.png" alt="">
                </template>
                <template v-if="result.title === '推理' && result.score > 5 && result.score <= 7">
                  <img src="../../assets/revt/tuili_6-7.png" alt="">
                </template>
              </td>
            </tr>
          </template>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="title3 tx-l">量表与全测验</p>
        <table border="1">
          <template>
            <tr v-for="(result,index) in allResult" :key="index">
              <td style="width: 75px;">{{ result.title }}</td>
              <td>
                {{result.res}}
              </td>
            </tr>
          </template>
        </table>
        <p class="title3 tx-l">施测者观察记录</p>
        <table border="1">
          <tr>
            <td style="height: 250px;"></td>
          </tr>
        </table>
        <div style="text-align: center;padding: 10px 0 25px 0;font-size: 16px;font-weight: bold;color: #333">如果您对本测验结果或解释有任何疑问，或是想进一步了解的地方请与施测人员联系沟通。</div>

      </div>

    </div>
    <button class="print" v-on:click="printPdf">打印</button>
    <!--底部-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav";
import FooterNav from "@/components/FooterNav";
import echarts from "echarts";
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import * as jspdf from 'jspdf'

export default {
  name: "aboutus",
  data() {
    return {
      current: "",
      baseInfo:{},
      isPrint: false,
      allEchart:{},
      cateEchart:{},
      cateResult:{},
      allResult:{},
      tip:true
    };
  },
  components: {
    HeaderNav,
    FooterNav
  },
  methods: {
    getData() {
      let params = {
        exam_id: this.$route.query.eid
      };
      this.$post("report/getReport", params)
          .then(res => {
            if (res.code === 1) {
              this.baseInfo = res.data.base_info
              this.allEchart = res.data.all
              this.cateEchart = res.data.cate
              this.cateResult = res.data.result.cate
              this.allResult = res.data.result.other
              this.$nextTick(() => {
                this.drawLine(this.cateEchart.echart); //页面上没有charts2元素，会报错
                this.drawLine2(this.allEchart.echart);
              });
              this.$nextTick(() => {
                if (this.$route.query.print) {
                  this.printPdf();
                }
              });

            } else {
              this.$layer.msg(res.msg);
            }
          })
          .catch(response => {
            this.$layer.msg("网络异常，请稍后重试！");
          });
    },
    printPdf() {
      this.exportPDF()
      return false
      this.isPrint = true;
      setTimeout(() => {
        this.getPdf("三岁至六岁汉语婴幼儿沟通及语言筛查测验", () => {
          this.isPrint = false;
        });
      }, 1500)
    },
    drawLine2(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("charts3"));
      // 绘制图表
      // 绘制图表
      let seriesLabel = {
        normal: {
          show: true,
          color: "black",
          position: "right" //在上方显示
        }
      };
      myChart.setOption({
        title: {
          text: "量表分数结果",
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "100px",
          right: "8%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            name: "计分类型",
            type: 'category',
            data: [
              "理解量表",
              "表达量表",
              "全测验"
            ]
          }
        ],
        yAxis: {
          name: "标准分数",
          type: "value",
          min:60,
          max:150,
          interval:10
        },
        series: [
          {
            // type: "line",
            type: "bar",
            barWidth:'18%',
            label: seriesLabel,
            data: data,
          }
        ]
      });
    },
    drawLine(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("charts2"));
      // 绘制图表
      let seriesLabel = {
        normal: {
          show: true,
          color: "black",
          position: "right" //在上方显示
        }
      };
      myChart.setOption({
        title: {
          text: "分测验分数结果",
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["听懂", "说出"],
          orient: "horizontal",
          x: "right",
          y: "top"
        },
        grid: {
          left: "107px",
          right: "6%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            name: "分测项",
            type: 'category',
            data: [
              "命名",
              "归类",
              "定义",
              "推理"
            ]
          }
        ],
        yAxis: {
          name: "标准分数",
          type: "value",
          data: [1,3,5,7,9,11,13,15,17,19],
          min:1,
          max:19,
          interval:2
        },
        series: [
          {
            type: "bar",
            barWidth:'20%',
            label: seriesLabel,
            data: data,
          }
        ]
      });
    },
    async exportPDF() {
      const element = document.getElementById("pdfDom")
      const pdf = new jsPDF("p","mm","a4")
      const pageWidth = 210
      const pageHeight = 297
      let positionY = 10

      const elements = Array.from(element.children)
      console.log(elements)
      function captureElement(index){
        if (index >= elements.length){
          pdf.save('export.pdf')
          return
        }
        const child = elements[index]
        html2canvas(child,{scale:2}).then((canvas)=>{
          const imgData = canvas.toDataURL("image/png");
          const imgWidth = pageWidth - 20
          const imgHeight = (canvas.height * imgWidth) / canvas.width
          if (positionY + imgHeight > pageHeight - 10){
            pdf.addPage()
            positionY = 10
          }
          pdf.addImage(imgData,'PNG',10,positionY,imgWidth,imgHeight)
          positionY += imgHeight + 10
          captureElement(index + 1)
        })
      }
      captureElement(0)

      // html2canvas(element,{scale:2}).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png")
      //   const pdf = new jsPDF('p','mm','a4')
      //   const imgWidth = 210
      //   const pageHeight = 297
      //   const imgHeight = (canvas.height * imgWidth) / canvas.width
      //   let heightLeft = imgHeight
      //   let position = 0
      //   pdf.addImage(imgData,"PNG",0,position,imgWidth,imgHeight)
      //   heightLeft -= pageHeight
      //   while (heightLeft > 0){
      //     position -= pageHeight
      //     pdf.addPage()
      //     pdf.addImage(imgData,"PNG",0,position,imgWidth,imgHeight)
      //     heightLeft -= pageHeight
      //   }
      //   pdf.save('test.pdf')
      // })
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/page/result");
/*模拟对角线*/
.out{
  border-top:40px transparent solid;/*上边框宽度等于表格第一行行高*/
  width:0px;/*让容器宽度为0*/
  height:0px;/*让容器高度为0*/
  border-left:130px transparent solid;/*左边框宽度等于表格第一行第一格宽度*/
  position:relative;/*让里面的两个子容器绝对定位*/
  font-size: 14px;
}

.table-cate {
  font-style: normal;
  display: block;
  position: absolute;
  top: -40px;
  left: -50px;
  width: 50px;
}

em {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  right: 80px;
  width: 50px;
}
.score-td{
  text-align: center;
}
.score-td-title{
  width: 95px;
  text-align: center;
}
.title3{
  font-weight: bold;
}
.input > span{
  padding: 0 10px;
}
</style>
